<template>
    <div
        v-if="isComponentReady"
        :class="{ [`l-ss-c-search-popup-wrapper-inbuilt`]: !$configuration.isPopup }"
        class="l-ss-c-search-popup-wrapper">
        <div
            :class="{ 'l-ss-c-search-popup-wrapper-mask-hidden': isShowAgeCheckPopup }"
            :style="zIndexPopup"
            class="l-ss-c-search-popup-wrapper-mask"
            @mousedown="mousedownClose"
            @click.self="onClickOutside">
            <div
                :class="{
                    [`l-ss-c-search-popup-is-opened-mobile-nav`]: showMobileNavigation,
                    [`l-ss-c-search-popup-is-loading`]: isLoading,
                    [`l-ss-c-search-popup-is-masked`]: isMaskVisible,
                    'l-ss-c-search-popup__shadow': $configuration.showInput,
                    ...wrapperClasses,
                }"
                class="l-ss-c-search-popup">
                <div
                    v-show="isMaskVisible"
                    class="l-ss-c-search-popup-mask"
                    @click="onPopupMaskClick"></div>
                <popup
                    v-if="$configuration.features.imageSearch"
                    :opened="store.state.ui.isImageSearchVisible"
                    :title="$t('imageSearch.title')"
                    class="l-ss-c-search-popup-image-search-popup"
                    @close="() => toggleImageSearch(false)">
                    <image-search-container
                        :base-image="base64Image"
                        :base-image-result="base64ImageResult"
                        @search="onImageSearch"
                        @base64-change="onFileBase64Change"
                        @crop-change="onCropChange"
                        @image-search-button-select-file-click="value => $emit('image-search-button-select-file-click', value)"
                        @image-search-use-correct-link-click="value => $emit('image-search-use-correct-link-click', value)"
                        @image-search-use-incorrect-link-click="value => $emit('image-search-use-incorrect-link-click', value)"
                        @image-search-button-search-click="value => $emit('image-search-button-search-click', value)"/>
                </popup>
                <popup
                    :opened="store.state.ui.isFiltersOpened"
                    :title="$t('filters.titleAll')"
                    class="l-ss-c-search-popup-filters-popup"
                    @close="() => toggleFilters(false)">
                    <section-full-filters
                        :filters="filterItems"
                        :has-results="hasResults"
                        :has-selected="hasFilters"
                        :total-items-count="totalItemsCount"
                        :values="filterValues"
                        @change="filters => $emit('filters-change', filters)"
                        @filter-click="params => $emit('filter-click', params)"
                        @close="() => toggleFilters(false)"
                        @reset="() => $emit('reset-filters')"/>
                </popup>
                <age-check-popup
                    v-if="isShowAgeCheckPopup"
                    :is-show="true"
                    @close="() => toggleAgeCheckPopup(false)"
                    @deny="onDenyAgeCheck"/>
                <div class="l-ss-c-search-popup-content-wrapper">
                    <div
                        v-if="$configuration.showInput"
                        :style="topSectionWrapperStyles"
                        class="l-ss-c-search-top-section-wrapper l-ss-c-search-popup-content-wrapper-child">
                        <div
                            :class="{ 'l-ss-c-search-popup-top-section-full-width': this.$configuration.completionsFullWidth }"
                            class="l-ss-c-search-popup-top-section">
                            <img
                                v-if="$configuration.logoSrc && !$screen.isMobile && logoAccess"
                                :src="$configuration.logoSrc"
                                @error="onLoadLogo()"
                                class="l-ss-c-search-popup-logo"
                                @click="() => $emit('search-popup-close')">
                            <categories-dropdown
                                v-if="$configuration.features.catalog && !$screen.isMobile"
                                :categories="allCategoriesList"
                                :data-border-radius="$screen.isMobile === false"
                                :has-filters="hasFilters"
                                :has-query="hasQuery"
                                :is-loading="isCategoriesLoading"
                                :selected-category-id="localSelectedCategoryId"
                                @update-category-id="setSelectedCategoryId"
                                @change="params => emitNavigateCategory(params)"
                                @toggle="onToggleCategories"
                                @button-everywhere-click="value => $emit('button-everywhere-click', value)"
                                @rubricator-category-click="value => $emit('rubricator-category-click', value)"
                                @reset-filters="() => $emit('reset-filters')"
                                @reset-query="() => $emit('reset-query')"/>
                            <search-input
                                v-if="!$screen.isMobile || ($screen.isMobile && !store.state.ui.isCategoriesListVisible)"
                                ref="searchInput"
                                :data-border-radius="$screen.isMobile === true"
                                :enable-image-search="$configuration.features.imageSearch"
                                :enable-voice-search="$configuration.features.voiceSearch"
                                :is-cart-available="$configuration.features.addToCartButton"
                                :is-loading="isLoading"
                                :show-actions="true"
                                v-bind="$props"
                                @blur="args => onSearchInputAction('search-input-blur', args)"
                                @change="args => onSearchInputAction('search-input-change', args)"
                                @focus="args => onSearchInputAction('search-input-focus', args)"
                                @keyUpEnter="params => onSearchInputAction('search-input-enter', params)"
                                @toggle-image-picker="args => onSearchInputAction('toggle-image-picker', args)"
                                @toggle-voice-search="value => $emit('voice-search', value)"
                                @autocomplete-search="onAutocompleteSearch"
                                @handle-search="args => onSearchInputAction('handle-search', args)"
                                @reset-query="args => onSearchInputAction('reset-query', args)"
                                @popup-close="args => onSearchInputAction('reset-query', args)"
                                @offer-click="value => $emit('offer-click', value)"
                                @category-click="value => $emit('category-click', value)"
                                @special-offers-click="value => $emit('special-offers-click', value)"
                                @suggestions-click="value => $emit('suggestions-click', value)"
                                @brand-click="value => $emit('brand-click', value)"
                                @history-click="value => $emit('brand-click', value)"
                                @popular-click="value => $emit('popular-click', value)"
                                @button-image-click="value => $emit('button-image-click', value)"
                                @search-click="value => $emit('search-click', value)"
                                @preview-tab-click="(value) => $emit('preview-tab-click', value)"
                                @delete-all-text="value => $emit('delete-all-text', value)"
                                @search-all="$emit('search-all')"
                                @preview-show-all-click="(value) => $emit('preview-show-all-click', value)"
                                @params-search="onParamsSearch"
                                @add-to-cart="args => onSearchInputAction('add-to-cart', args)"
                                @remove-history="(params) => $emit('remove-history', params)"
                                @completions-close="$emit('completions-close')"
                                @completions-open="(params) =>$emit('completions-open', params)"/>
                            <button
                                class="l-ss-c-button l-ss-c-button-plain l-ss-c-search-popup-close-button"
                                @click="onClickCloseButton">
                                <i
                                    class="l-ss-c-icon l-ss-c-search-input-icon-close-popup"
                                    v-html="iconClosePopup"></i>
                            </button>
                        </div>
                        <div
                            v-if="isResultsVisible"
                            class="l-ss-c-popup-slot-top">
                            <autocomplete
                                :is-loading="isLoading"
                                :search="search"
                                class="l-ss-c-popup-slot-top-column l-ss-c-popup-slot-top-column-is-left"
                                @autocomplete-search="onAutocompleteSearch"
                                @params-search="params => $emit('params-search', params)"/>
                        </div>
                    </div>

                    <div
                        v-if="isShowResultsLoader"
                        class="l-ss-c-results-loader">
                        <pulse-dots/>
                    </div>

                    <div
                        v-else
                        :class="{ 'l-ss-c-filters-left': filterPositionLeft }"
                        :style="!$configuration.showInput ? 'padding-top: 0' : ''">
                        <section-image
                            v-if="store.state.ui.isImageContours || base64Image"
                            :image="store.state.ui.isImageContours || { contours: [], src: '' }"
                            :key="sectionImageKey"
                            @search="onImageSearch"
                            @crop-change="onCropChange"
                            @contour-click="$contour => $emit('contour-click', $contour)"/>
                        <div :class="{ 'l-ss-c-filters-left-container': filterPositionLeft }">
                            <section-filters
                                v-show="isFiltersBlockVisible && isResultsVisible"
                                :currency="currencyInOffers"
                                :filter-position-left="filterPositionLeft"
                                :filters="filterItems"
                                :has-results="hasResults"
                                :has-selected="hasFilters"
                                :show-sorting="showSorting"
                                :sort-by="sortBy"
                                :sort-dest="sortDest"
                                :total-items-count="totalItemsCount"
                                :values="filterValues"
                                search-type="search-popup"
                                class="l-ss-c-search-popup-content-wrapper-child"
                                ref="sectionFilters"
                                @change="filters => $emit('filters-change', filters)"
                                @filter-click="params => $emit('filter-click', params)"
                                @sort-change="params => $emit('sort-change', params)"
                                @result-sort-click="params => $emit('result-sort-click', params)"
                                @reset-filters="() => $emit('reset-filters')"
                                @close-filters="() => toggleFilters(false)"
                                @open-filters="() => toggleFilters(true)"/>
                            <section-results
                                v-if="isResultsVisible"
                                ref="search-results"
                                :categories="allCategoriesList"
                                :category-id="resultsCategoryId"
                                :error-text="requestErrorText"
                                :filter-position-left="filterPositionLeft"
                                :group-categories="$configuration.features.shouldGroupCategories"
                                :has-filters="hasFilters"
                                :has-loaded-once="hasLoadedOnce"
                                :has-query="hasQuery"
                                :has-results="hasResults"
                                :is-loading="isLoading"
                                :limit="limit"
                                :search="searchResponse"
                                :search-request-id="searchRequestId"
                                :skip="skip"
                                :templates="offerTemplates"
                                :total-items-count="totalItemsCount"
                                :query="query"
                                class="l-ss-c-search-popup-content-wrapper-child"
                                @navigate-category="handleNavigateCategory"
                                @navigate-page-next="() => $emit('navigate-page-next')"
                                @navigate-page-prev="() => $emit('navigate-page-prev')"
                                @reset-category="onResetCategory"
                                @offer-click="params => $emit('offer-click', params)"
                                @add-to-cart-click="params => $emit('add-to-cart-click', params)"
                                @add-to-cart="args => onSearchInputAction('add-to-cart', args)"
                                @reset-filters="() => $emit('reset-filters')"
                                @reset-query="() => $emit('reset-query')"
                                @handle-tags-click="(value) => onTapAction(value)"
                                @result-tab-click="(value) => $emit('result-tab-click', value)"
                                @result-category-click="(value) => $emit('result-category-click', value)"
                                @view-in-category-click="(value) => $emit('view-in-category-click', value)"
                                @page-reload="handlePageReload"
                                @scroll-to-top="handleScrollToTop">
                                <template #filtersSort>
                                    <section-filters-sort
                                        v-if="isFiltersBlockVisible && isResultsVisible && filterPositionLeft"
                                        :filter-position-left="filterPositionLeft"
                                        :filters="filterItems"
                                        :show-sorting="showSorting"
                                        :sort-by="sortBy"
                                        :sort-dest="sortDest"
                                        class="l-ss-c-search-popup-content-wrapper-child"
                                        @sort-change="params => $emit('sort-change', params)"
                                        @result-sort-click="params => $emit('result-sort-click', params)"/>
                                </template>
                                <template #top>
                                    <custom-block
                                        v-if="$configuration.searchResult.topBlock"
                                        :custom-template="$configuration.searchResult.topBlock"/>
                                    <info-banner v-if="from_completions">
                                        <span>{{ $t('selectedFiltersText') }}: {{ from_completions }}</span>
                                        <button
                                            class="l-ss-c-button l-ss-c-filters-full-action l-ss-c-button-secondary"
                                            @click="() => $emit('reset-filters')">
                                            {{ $t('filters.resetAllText') }}
                                        </button>
                                    </info-banner>
                                    <info-banner v-show="search && search.hits > $configuration.limitForQueryRefine">
                                        <span>{{ $t('results.overLimitResults') }}</span>
                                    </info-banner>
                                </template>
                            </section-results>
                        </div>
                    </div>

                    <div
                        v-if="isShowSignature"
                        class="l-ss-c-signature">
                        <a
                            ref="signatureLeft"
                            class="l-ss-c-signature__caption"></a>
                        <a
                            ref="signatureRight"
                            class="l-ss-c-signature__caption"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { installPlugins } from '../core/plugins';
    import Autocomplete from '../core/components/autocomplete';
    import SearchInput from '../core/components/search-input';
    import RootComponentMixin from '../core/mixins/root-component';
    import CompletionsMixin from '../core/mixins/completions';
    import SearchResultsMixin from '../core/mixins/search-results-mixin';
    import CategoriesDropdown from '../core/components/categories-dropdown';
    import SectionResults from '../core/components/section-results';
    import SectionFilters from '../core/components/filters/section-filters';
    import SectionFiltersSort from '../core/components/filters/section-filters-sort';
    import ImageSearchContainer from '../core/components/image-search-container';
    import iconClosePopup from '../core/assets/images/icons/close-popup.svg';
    import Popup from '../core/components/popup';
    import AgeCheckPopup from '../core/components/age-check-popup';
    import InfoBanner from '../core/components/info-banner';
    import SectionFullFilters from '../core/components/filters/section-full-filters';
    import CustomBlock from '../core/components/custom-block';
    import SectionImage from '@/core/components/section-image';
    import PulseDots from '@/core/components/pulse-dots';
    import { getCookie } from '/src/core/helpers/cookies';

    const EVENT_CALLBACK_DELAY = 300;
    const POPOVER_Z_INDEX = 52;
    installPlugins();
    export default {
        components: {
            SectionImage,
            SectionFullFilters,
            Autocomplete,
            SearchInput,
            CategoriesDropdown,
            SectionFilters,
            SectionFiltersSort,
            SectionResults,
            ImageSearchContainer,
            InfoBanner,
            Popup,
            CustomBlock,
            AgeCheckPopup,
            PulseDots,
        },
        props: {
            ...CompletionsMixin.props,
            ...RootComponentMixin.props,
            ...SearchResultsMixin.props,
            from_completions: {
                type: String,
                default: '',
            },
            categoryId: {
                type: [String, Number],
                default: '',
            },
            query: {
                type: String,
                default: '',
            },
            params: {
                type: Array,
                default: () => ([]),
            },
            completions: {
                type: Array,
                required: false,
                default: () => ([]),
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
        },
        data() {
            return {
                localQueryParams: null,
                showMobileNavigation: false,
                base64Image: null,
                base64ImageResult: null,
                showSearch: true,
                wrapperClickTarget: null,
                isBase64ImageChanged: false,
                sectionImageKey: '',
                localSelectedCategoryId: '',
                logoAccess: true,
            };
        },

        computed: {
            ...CompletionsMixin.computed,
            ...RootComponentMixin.computed,
            ...SearchResultsMixin.computed,
            filterPositionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile && this.totalItemsCount >
                    0;
            },
            zIndexPopup() {
                return this.$configuration.isPopup ? { 'z-index': 999888 } : { 'z-index': 100 };
            },
            topSectionWrapperStyles() {
                return {
                    zIndex: this.isTopSectionOnFrontLayer ? POPOVER_Z_INDEX : 'initial',
                    backgroundColor: this.store.state.ui.isCompletionsVisible && !this.$screen.isMobile ?
                        'transparent' :
                        'inherit',
                };
            },
            requestErrorText() {
                return this.errorTextCompletions || this.errorTextSearch || '';
            },
            isMaskVisible() {
                return this.store.state.ui.isImageSearchVisible ||
                    this.store.state.ui.isCategoriesListVisible ||
                    this.store.state.ui.isFiltersOpened ||
                    this.showCompletions;
            },
            isTopSectionOnFrontLayer() {
                return (this.store.state.ui.isCategoriesListVisible && !this.$screen.isMobile) || this.showCompletions;
            },
            isShowSignature() {
                return Boolean(this.hasResults) && this.store.state.ui.isShowSignature;
            },
            iconClosePopup() {
                return iconClosePopup;
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            categoriesResponse() {
                return this.requestCategories ? this.requestCategories.response : null;
            },
            allCategoriesList() {
                return this.categoriesResponse || [];
            },
            showSorting() {
                return (Boolean(this.hasResults));
            },
            isShowAgeCheckPopup() {
                return this.store.state.ui.isShowAgeCheckPopup;
            },
            isShowResultsLoader() {
                if (this.isLoading) {
                    return !this.hasResults || this.hideResults;
                }
                return false;
            },
        },

        watch: {
            'searchState.public': function (state) {
                if (this.localQueryParams && this.localQueryParams.query !== state.query) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                    this.resetImage();
                }
                this.localQueryParams = state ? { ...state } : {};
            },
            base64Image() {
                this.isBase64ImageChanged = true;
            },
        },

        beforeCreate() {
            Object.assign(this, { projectName: 'SearchBooster.io' });
            Object.assign(this, { href: 'https://searchbooster.io/' });
        },

        mounted() {
            this.$on('search-input-change', () => {
                this.resetImage();
            });
            this.$on('handle-search', () => {
                this.resetImage();
            });
            this.addCss(this.$configuration.searchResult.topBlock.customCss);
        },

        updated() {
            this.setValueToSignature();
        },

        methods: {
            ...RootComponentMixin.methods,
            ...SearchResultsMixin.methods,
            onLoadLogo() {
                this.logoAccess = false;
            },
            addCss(cssCode) {
                let shDom = document.querySelector('searchbooster-search-popup');
                let style = document.createElement('style');
                if (style.styleSheet) {
                    style.styleSheet.cssText = cssCode;
                } else {
                    style.appendChild(document.createTextNode(cssCode));
                }
                shDom.shadowRoot.appendChild(style);
            },
            onClickOutside(event) {
                if (this.wrapperClickTarget === event.target) {
                    this.handleCloseWidgetCommonActions();
                    this.closeWidgetClick('lossFocus', event);
                }
            },
            onClickCloseButton(event) {
                this.handleCloseWidgetCommonActions();
                this.closeWidgetClick('buttonClick', event);
            },
            handleCloseWidgetCommonActions() {
                this.$emit('reset-query');
                this.resetImage();
                this.resetSelectedCategoryId();
                this.$emit('search-popup-close');
            },
            closeWidgetClick(clickType, event) {
                this.$emit('close-widget-click', {
                    type: 'closeWidget',
                    query: this.query,
                    customEventType: clickType,
                    event,
                });
            },
            mousedownClose(event) {
                this.wrapperClickTarget = event.target;
            },
            onToggleCategories(value) {
                const resultValue = value === undefined ? !this.store.state.ui.isCategoriesListVisible : !!value;
                if (resultValue) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                }
                this.store.state.ui.isCategoriesListVisible = resultValue;
                if (resultValue) {
                    this.$emit('search-popup-fetch-categories');
                }
            },
            onFileBase64Change(base64Image) {
                this.base64Image = base64Image;
            },
            onCropChange(event) {
                this.base64ImageResult = event.canvas.toDataURL('image/jpeg');
            },
            onImageSearch() {
                if (this.isBase64ImageChanged) {
                    this.isBase64ImageChanged = false;
                    this.sectionImageKey = this.base64Image;
                }

                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.$emit('search-image', { base64: this.base64ImageResult });
                /*
                 * SetTimeout(() => {
                 *     this.resetImage();
                 * }, RESET_IMAGE_BASE_64_DELAY);
                 */
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                this.resetImage();
            },
            resetImage() {
                this.base64Image = null;
                this.base64ImageResult = null;
            },
            toggleAgeCheckPopup() {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isShowAgeCheckPopup',
                    value: !this.store.state.ui.isShowAgeCheckPopup,
                });
            },
            onPopupMaskClick() {
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.resetImage();
            },
            onSearchInputAction(eventName, params) {
                let afterEventCallback = null;
                switch (eventName) {
                    case 'search-input-change':
                        this.$emit(eventName, params);
                        break;
                    case 'handle-search':
                        this.toggleFilters(false);
                        this.$emit(eventName);
                        break;
                    case 'toggle-image-picker':
                        this.toggleImageSearch(params);
                        break;
                    case 'popup-close':
                        this.$emit('search-popup-close');
                        break;
                    case 'search-input-blur':
                        this.$emit('search-input-blur');
                        break;
                    case 'search-input-focus':
                        this.$emit('search-input-focus');
                        break;
                    case 'search-input-enter':
                        this.$emit(eventName, params);
                        break;
                    case 'reset-query':
                        this.base64Image = null;
                        this.resetSelectedCategoryId();
                        this.$emit(eventName, params);
                        break;
                    case 'add-to-cart':
                        this.$emit(eventName, params);
                        break;
                    case 'remove-history':
                        this.$emit('remove-history');
                        break;
                    default:
                        afterEventCallback = () => {
                            this.showSearch = true;
                        };
                        this.$emit(eventName, params);
                }
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                if (afterEventCallback) {
                    setTimeout(afterEventCallback, EVENT_CALLBACK_DELAY);
                }
            },
            setValueToSignature() {
                if (!this.isShowSignature)
                    return;
                const i18nStr = this.$t('signature', [this.projectName]);
                const preparedValue = i18nStr.replace(this.projectName, '');
                const refsList = i18nStr.indexOf(this.projectName) === 0
                    ? [this.$refs.signatureLeft, this.$refs.signatureRight]
                    : [this.$refs.signatureRight, this.$refs.signatureLeft];
                if (!refsList.some(Boolean))
                    return;
                refsList[0].innerText = this.projectName;
                refsList[0].href = this.href;
                refsList[0].target = '_blank';
                refsList[1].innerText = preparedValue;
            },
            onTapAction(value) {
                this.$emit('search-input-change', { query: value, focus: false });
                this.onSearchInputAction('handle-search');
            },
            onDenyAgeCheck() {
                if (this.$configuration.features.ageCheckPopupType === 'filter') {
                    this.$emit('search-all');
                } else {
                    this.$emit('reset-query');
                    this.$emit('search-popup-close');
                    window.location.href = getCookie('ageCheckPopupRedirectUrl', this.$configuration.ageCheckPopupRedirectUrl);
                }
            },
            setSelectedCategoryId(categoryId) {
                this.localSelectedCategoryId = categoryId;
            },

            resetSelectedCategoryId() {
                this.localSelectedCategoryId = '';
            },

            onParamsSearch(params) {
                this.resetSelectedCategoryId();
                this.$emit('params-search', params);
            },

            onResetCategory() {
                this.resetSelectedCategoryId();
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategorySearch', value: false });
                this.emitNavigateCategory({ skip: 0, categoryId: '' });
            },

            onAutocompleteSearch(value) {
                this.resetSelectedCategoryId();

                this.$emit('autocomplete-search', value);
            },
        },
    };
</script>
